import router from '@/router';

const resolveRoute = async name => {
    try {
        return await router.resolve({ name });
    } catch (error) {
        return null;
    }
};

export default resolveRoute;
